export const COMERCIALOFFER_ID = 17338;
export const RELEVANT_DOCUMENTATION_ID = 17318;
export const NORMATIVE_COMPLIANCE_ID = 20217;
export const CORPORATE_IMAGE_ID = 20136;
export const PREVENTION_SSMM_ID = 20210;
export const DATA_PROTECTION_ID = 20200;
